window.Leaflet = require('leaflet');

function DBKloadMaps() {
    $('.map-container').each(function() {
        let $canvas = $('[id*="map-canvas-"]', this);

        if ($canvas.length > 0) {
            $canvas.css('height', '100%');
        }

        let latitude = $canvas.data('center-lat'),
            longitude = $canvas.data('center-long'),
            zoom = $canvas.data('zoom') || 15,
            markers = $canvas.data('markers') || [];

        // if on mobile, decrease zoom level
        if (viewport().width < 768) {
            zoom = parseInt(zoom) - 1;
        }

        let map = Leaflet.map($canvas.attr('id'), {
            center: [latitude, longitude],
            zoom: zoom,
            scrollWheelZoom: false,
            tap: false,
            attributionControl: false
        });

        // add map tiles
        Leaflet.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_2mgw_1_17a7da28759f709cd9ddd5ea', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 20
        }).addTo(map);

        $('.leaflet-reset-view', this).on('click', function () {
            map.closePopup().setView([latitude, longitude], zoom);
        });

        for (const marker of markers) {
            if (marker.lat && marker.long) {
                let myMarker;

                let pin_icon = Leaflet.icon({
                    iconUrl: assetsImageUrl + 'theme/pin-main.svg',
                    iconSize: [60, 60],
                    iconAnchor: [30, 60],
                    popupAnchor: [0, -65]
                });

                // create marker
                myMarker = Leaflet.marker([marker.lat, marker.long], {icon: pin_icon});

                // add marker to map
                myMarker.addTo(map).bindPopup(marker.popup_content);

                if (markers.length === 1) {
                    myMarker.openPopup();
                    map.panBy([0, -80]);
                }
            }
        }
    });
}

if ($('.map-canvas').length > 0 && window.viewport().width > 768) {
    DBKloadMaps();
}

$('.btn--show-map').on('click', function () {
    DBKloadMaps();
});
